module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya/nagoya_concept_03-abb5a3cc84e0a01b0d7faf29134f4d7b.jpg";